import { useMutation, useQueryClient } from 'react-query'
import { triggerRemittance } from '../api/merchant-cash-advances.api'

export const useTriggerRemittance = (merchantId: string) => {
  const queryClient = useQueryClient()

  return useMutation(
    () => {
      return triggerRemittance(merchantId)
    },
    {
      onSuccess: () => {
        // Invalidate cash advances and repayments to refresh the data
        queryClient.invalidateQueries({
          queryKey: ['cash-advances', merchantId],
        })
        queryClient.invalidateQueries({
          queryKey: ['cash-advance-repayments', merchantId],
        })
      },
    },
  )
}
